<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7473 6.1083C11.7473 6.64997 11.3139 7.0833 10.7723 7.0833H6.87225V10.7666C6.87225 11.3083 6.43892 11.7416 5.89725 11.7416C5.35558 11.7416 4.92225 11.3083 4.92225 10.7666V7.0833H1.23892C0.697249 7.0833 0.263916 6.64997 0.263916 6.1083C0.263916 5.56664 0.697249 5.1333 1.23892 5.1333H4.92225V1.2333C4.92225 0.691634 5.35558 0.258301 5.89725 0.258301C6.43892 0.258301 6.87225 0.691634 6.87225 1.2333V5.1333H10.7723C11.3139 5.1333 11.7473 5.56664 11.7473 6.1083Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: "plusIconNoBorder",
    props: {
      fill: {
        type: String,
        default: 'white'
      }
    }
  }
</script>

<style scoped>

</style>
